
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { TaskFormData } from "@/types/task";

interface Props {
  formData: TaskFormData;
  setFormData: (data: TaskFormData) => void;
}

export const TaskFormScheduling = ({ formData, setFormData }: Props) => (
  <>
    <div className="space-y-2">
      <Label htmlFor="due_date">تاريخ الاستحقاق</Label>
      <Input
        id="due_date"
        type="date"
        value={formData.due_date || ''}
        onChange={(e) => setFormData({ ...formData, due_date: e.target.value })}
      />
    </div>

    <div className="space-y-2">
      <Label htmlFor="estimated_hours">الساعات المتوقعة</Label>
      <Input
        id="estimated_hours"
        type="number"
        min="0"
        value={formData.estimated_hours || ""}
        onChange={(e) => setFormData({ ...formData, estimated_hours: e.target.value ? parseInt(e.target.value) : undefined })}
        placeholder="عدد الساعات"
      />
    </div>
  </>
);
